import React from "react";
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Divider,
} from "@mui/material";
import GetEBookButton from "./GetEBookButton";

const bonuses = [
    {
        title: "Bonus: 1",
        headline: "Weekly Planner",
        image: "/assets/bonuses-weekly-planner.png",
        description: (
            <>
                <Typography variant="body1" color="text.secondary">
                    This Weekly Planner is a gentle tool to help your child develop important life skills—like organization, responsibility, and emotional awareness—while keeping things light and fun.
                </Typography>
            </>
        ),
    },
    {
        title: "Bonus: 2",
        headline: "Anger Management",
        image: "/assets/bonuses-anger-management.png",
        description: (
            <>
                <Typography variant="body1" color="text.secondary">
                    Anger is a normal emotion—just like joy or sadness. It’s part of being human, and even children feel it often when things don’t go their way or when they feel misunderstood. What truly matters is helping them learn how to recognize it and manage it in healthy ways.
                </Typography>
            </>
        ),
    },
    {
        title: "Bonus: 3",
        headline: "Weekly Rewards",
        image: "/assets/bonuses-weekly-rewards.png",
        description: (
            <>
                <Typography variant="body1" color="text.secondary">
                    This Weekly Rewards Chart is designed to help children build good routines while learning that effort, responsibility, and kindness are worth celebrating.
                </Typography>
            </>
        ),
    },
    {
        title: "Bonus: 4",
        headline: "Mother & Daughter Printable",
        image: "/assets/bonuses-for-cyj.png",
        description: (
            <>
                <Typography variant="body1" color="text.secondary">
                    A gentle, heart-centered poster to help you slow down and savor small magical moments with your daughter. Includes simple prompts, sweet rituals, and reflection ideas to make her feel seen, safe, and deeply loved.
                </Typography>
            </>
        ),
    },
    {
        title: "Bonus: 5",
        headline: "Mother & Son Printable",
        image: "/assets/bonuses-for-cyj.png",
        description: (
            <>
                <Typography variant="body1" color="text.secondary">
                    Playful, warm prompts designed to spark laughter and conversation with your son. Helps him feel understood and appreciated while turning ordinary moments into joyful memories.
                </Typography>
            </>
        ),
    },
];
const BonusSection = () => (
    <Box
        component="section"
        sx={{
            bgcolor: "background.default",
            mb: 6,
        }}
    >
        <Divider sx={{ mb: 4 }} />

            {/* Primary three bonuses */}
            <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center" sx={{ mb: { xs: 2, md: 3 } }}>
                {bonuses.slice(0, 3).map((bonus, idx) => (
                    <Grid item xs={12} sm={6} md={4} key={idx} >
                        <Card  elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", p: { xs: 2, md: 2.5 }, bgcolor: "custom.red", borderRadius: 2, border: "1px solid", borderColor: "divider" }}>
                            <CardMedia component="img" image={bonus.image} alt={bonus.headline} sx={{ width: { xs: 220, md: 240 }, height: "auto", mb: 2, borderRadius: 1, objectFit: "contain" }} loading="lazy" />
                            <CardContent sx={{ flexGrow: 1, textAlign: "center", width: "100%" }}>
                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 600 }}>{bonus.title}</Typography>
                                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{bonus.headline}</Typography>
                                <Box sx={{  }}>{bonus.description}</Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Special bonuses layout: image centered, bonuses on sides */}
            <Grid container spacing={{ xs: 2, md: 3 }} alignItems="stretch" justifyContent="center">
                {/* Left special bonus (Bonus 4) */}
                <Grid item xs={12} md={4}>
                    <Card elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", p: { xs: 2, md: 2.5 }, bgcolor: "custom.red", borderRadius: 2, border: "1px solid", borderColor: "divider" }}>
                        <CardContent sx={{ flexGrow: 1, textAlign: "center", width: "100%" }}>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 600 }}>{bonuses[3].title}</Typography>
                            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{bonuses[3].headline}</Typography>
                            <Box sx={{  }}>{bonuses[3].description}</Box>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Center image */}
                <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Card elevation={0} sx={{ p: { xs: 2, md: 3 }, bgcolor: 'transparent', textAlign: 'center' }}>
                        <CardMedia component="img" image={bonuses[3].image} alt="Special Bonuses" sx={{ width: { xs: 240, md: 300 }, height: 'auto', borderRadius: 2, objectFit: 'contain', mx: 'auto' }} />
                    </Card>
                </Grid>

                {/* Right special bonus (Bonus 5) */}
                <Grid item xs={12} md={4}>
                    <Card elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", p: { xs: 2, md: 2.5 }, bgcolor: "custom.red", borderRadius: 2, border: "1px solid", borderColor: "divider" }}>
                        <CardContent sx={{ flexGrow: 1, textAlign: "center", width: "100%" }}>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 600 }}>{bonuses[4].title}</Typography>
                            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{bonuses[4].headline}</Typography>
                            <Box sx={{  }}>{bonuses[4].description}</Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        <Typography
            variant="subtitle1"
            sx={{ textAlign: "center", mt: { xs: 2, md: 5 }, fontWeight: 600 }}
        >
            All bonuses are instantly downloadable and printable — only available for a limited time!
        </Typography>
            {/* Ebook CTA */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: { xs: 3, md: 4 } }}>
                <GetEBookButton />
            </Box>
    </Box>
);
export default BonusSection;